import useSWR from 'swr';

import { fetchEndpointData } from '@/utils/fetch.client';

/**
 * One Fireworks model the platform serves, as the "New session" model picker
 * needs it. Mirrors `ModelInfo` in `routes/models.rs`; rates are µUSD per 1M
 * tokens so cost math stays integer, matching the backend price book.
 */
export interface ModelInfo {
  /** Client alias the session is created with and billed under (e.g. `kimi-k3`). */
  id: string;
  display_name: string;
  context_window: number;
  input_micro_usd_per_m: number;
  cached_input_micro_usd_per_m: number;
  output_micro_usd_per_m: number;
  /** Whether the model accepts image input — drives the composer's attach button. */
  supports_vision: boolean;
}

/** Mirrors `ModelList` in `routes/models.rs`. */
export interface ModelList {
  data: ModelInfo[];
  /** Client alias served when a session pins no model of its own. */
  default: string;
}

export const modelsKey = '/api/v1/models';

/**
 * The served-model catalogue for the model picker. The set is fixed in backend
 * code, so this never changes within a session — fetched once, no polling.
 */
export function useModels() {
  const { data, error, isLoading } = useSWR(modelsKey, () => fetchEndpointData<ModelList>(modelsKey), {
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });
  return { models: data?.data ?? [], defaultModel: data?.default ?? null, isLoading, error };
}
